import { render } from "./escalaGlasgow.vue?vue&type=template&id=197d0ae2&scoped=true"
import script from "./escalaGlasgow.vue?vue&type=script&lang=js"
export * from "./escalaGlasgow.vue?vue&type=script&lang=js"

import "./escalaGlasgow.vue?vue&type=style&index=0&id=197d0ae2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197d0ae2"]])

export default __exports__